import { render } from "./index.vue?vue&type=template&id=58f57ca8&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=58f57ca8&lang=scss"

import exportComponent from "C:\\Users\\Link\\Documents\\MCOM\\mcom-agri-origin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__